var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepartment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.143,
    height: 17.571,
    viewBox: "0 0 26.143 17.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44563",
    "data-name": "Group 44563",
    transform: "translate(0.147 0.147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89159",
    "data-name": "Path 89159",
    d: "M25.084,12V1.286A.536.536,0,0,0,24.548.75H10.619a.536.536,0,0,0-.535.536V2.358",
    transform: "translate(-1.981 -0.147)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89160",
    "data-name": "Path 89160",
    d: "M15.362,14.751H28.067c0,1.607-1.071,2.143-2.678,2.143H16.978",
    transform: "translate(-2.821 -2.898)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89161",
    "data-name": "Path 89161",
    d: "M6.631,12.787A3.294,3.294,0,0,1,3.417,9.342V8.194A3.293,3.293,0,0,1,6.631,4.751,3.293,3.293,0,0,1,9.845,8.194V9.342A3.294,3.294,0,0,1,6.631,12.787Z",
    transform: "translate(-0.671 -0.933)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89162",
    "data-name": "Path 89162",
    d: "M.75,19.571v-.964c0-2.643,3.451-3.857,5.357-3.857s5.357,1.192,5.357,3.835v.987",
    transform: "translate(-0.147 -2.898)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89163",
    "data-name": "Path 89163",
    d: "M18.893,8.774a2.2,2.2,0,0,0,2.143-2.3V5.713a2.148,2.148,0,1,0-4.286,0v.766A2.2,2.2,0,0,0,18.893,8.774Z",
    transform: "translate(-3.291 -0.671)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89164",
    "data-name": "Path 89164",
    d: "M21.845,12.226c0-1.467-2.071-2.143-3.214-2.143s-3.214.663-3.214,2.13",
    transform: "translate(-3.029 -1.981)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartment);
export default __webpack_public_path__ + "static/media/department.f379021a7af8f96820f774bc23983580.svg";
export { ForwardRef as ReactComponent };